export default "__VITE_ASSET__DVruk_dq__"